// src/lib/busca.js — busca "o que você vê é pesquisável".
// Em vez de enumerar campos, cada lista passa as PARTES já formatadas que a linha exibe
// (fornecedor, fmt(valor), fmtDate(venc), rótulo de status/origem, descrição…). A query casa
// contra isso, com normalização tolerante para valor e data.
//
// Regras:
//  - lowercase + remoção de acentos.
//  - multi-termo: a query é quebrada por espaço e TODOS os termos precisam casar (AND).
//  - valor/data: cada termo com dígito também tenta casar contra uma versão "só dígitos" das
//    partes, então "7200" acha "R$ 7.200,00", e "0708"/"07/08" acham "07/08/2026".
//    Para buscar por ISO (ex.: "2026-08"), a lista deve incluir a data crua entre as partes.

const _norm = (s) => String(s ?? '')
  .toLowerCase()
  .normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // tira acentos

const _digits = (s) => String(s ?? '').replace(/\D/g, '');

/**
 * @param {string} query  texto digitado na busca
 * @param {Array<any>} parts  valores exibidos pela linha (strings/números, já formatados)
 * @returns {boolean}
 */
export function matchBusca(query, parts) {
  const terms = _norm(query).trim().split(/\s+/).filter(Boolean);
  if (!terms.length) return true;
  const arr = Array.isArray(parts) ? parts : [parts];
  const textHay = arr.map(_norm).join(' ');
  const digitHay = arr.map(_digits).filter(Boolean).join(' ');
  return terms.every((t) => {
    if (textHay.includes(t)) return true;
    if (/\d/.test(t)) { const dt = _digits(t); if (dt && digitHay.includes(dt)) return true; }
    return false;
  });
}

export default matchBusca;
